import React, { useState, useEffect, useContext } from "react";
import { Outlet, useLocation } from "react-router-dom";
import axios from "axios";

import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import AppContext from "../../context/AppContext";

import "../../assets/css/layout/admin/AdminLayout.css";

const SGC_PAGE_TITLES = {
  "/admin": "Dashboard",
  "/admin/treatments": "Treatments",
  "/admin/appointments": "Appointments",
  "/admin/deals": "Deals",
  "/admin/blogs": "Blogs",
  "/admin/ai-content": "AI Content",
  "/admin/support": "Support",
  "/admin/profile": "Profile",
};

const AdminLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);
  const { pathname } = useLocation();
  const { baseUrl } = useContext(AppContext);

  const pageTitle = SGC_PAGE_TITLES[pathname] ?? "Dashboard";

  const refreshNotificationCount = () => {
    axios
      .get(`${baseUrl}/admin/notifications/viewLatestNotifications`)
      .then((response) => {
        setNotificationCount(response.data.count);
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    refreshNotificationCount();
    const interval = setInterval(refreshNotificationCount, 30000); // 30 sec poll
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="sgc-admin-layout">
      <AdminSidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div className="sgc-admin-main-col">
        <AdminHeader
          pageTitle={pageTitle}
          breadcrumb="Estetica Skin & Laser"
          notificationCount={notificationCount}
          adminName="Admin"
          onToggleSidebar={() => setSidebarOpen((prev) => !prev)}
          onNotificationChange={refreshNotificationCount}
        />

        <main className="sgc-admin-content">
          {children ?? <Outlet context={{ refreshNotificationCount }} />}
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;